import TagItem from './TagItem';

export default TagItem;
